module.exports = __webpack_public_path__ + "img/835.99688369.png";